<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.NEW_INDEXER
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <b-field class="column is-12" :label="General.INDEXER">
          <b-input
            v-model="name"
            :placeholder="General.PLACEHOLDER.NAME_INDEXER"
          />
        </b-field>
      </section>

      <footer class="modal-card-foot is-justify-content-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.INCLUDE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-orange'"
            class="is-outlined"
            @click="$emit('close')"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { App, General } from "@/utils/constants";

export default {
  data() {
    return {
      App,
      General,
      isLoading: false,
      name: ""
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  methods: {
    ...mapActions({
      indexerCreate: "indexerCreate",
      indexerRequest: "indexerRequest"
    }),

    async confirmAction() {
      await this.indexerCreate(this.name);
      await this.indexerRequest();
      this.close();
    },

    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 50vw;
  min-height: 100px;
  max-height: 75vh;
  background-color: $color-1;
}
.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
</style>
